document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.column-slider .column');
  const dots = document.querySelectorAll('.slider__dot');
  let isSliderActive = false;
  let currentSlide = 1;
  let touchStartX = 0;
  let touchEndX = 0;

  function handleTouchStart(e) {
    touchStartX = e.changedTouches[0].screenX;
  }

  function handleTouchEnd(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipeGesture();
  }

  // Add touch event
  function handleSwipeGesture() {
    const swipeDistance = touchEndX - touchStartX;

    if (swipeDistance > 50) {
      // swipe right
      currentSlide = Math.max(currentSlide - 1, 1);
      activateSlide(currentSlide);
    } else if (swipeDistance < -50) {
      // swipe left
      currentSlide = Math.min(currentSlide + 1, slides.length);
      activateSlide(currentSlide);
    }
  }

  function activateSlide(index) {
    const offset = (index - 1) * -100; // Calcula o deslocamento horizontal
    document.querySelector('.column-slider').style.transform = `translateX(${offset}%)`;

    dots.forEach(dot => {
      dot.classList.toggle('is-active', parseInt(dot.dataset.index) === index);
    });
  }

  function setupSlider() {
    if (isSliderActive) return;
    isSliderActive = true;

    activateSlide(1); // show the first slide

    dots.forEach(dot => {
      dot.addEventListener('click', handleDotClick);
    });

    slides.forEach(slide => {
      slide.addEventListener('touchstart', handleTouchStart);
      slide.addEventListener('touchend', handleTouchEnd);
    });
  }

  function destroySlider() {
    if (!isSliderActive) return;
    isSliderActive = false;

    document.querySelector('.column-slider').style.transform = 'translateX(0)'; // returning to default

    dots.forEach(dot => {
      dot.classList.remove('is-active');
      dot.removeEventListener('click', handleDotClick);
    });

    slides.forEach(slide => {
      slide.removeEventListener('touchstart', handleTouchStart);
      slide.removeEventListener('touchend', handleTouchEnd);
    });
  }

  function handleDotClick() {
    const index = parseInt(this.dataset.index);
    activateSlide(index);
  }

  const mediaQuery = window.matchMedia('(max-width: 767px)');

  function handleViewportChange(e) {
    if (e.matches) {
      setupSlider();
    } else {
      destroySlider();
    }
  }

  mediaQuery.addEventListener('change', handleViewportChange);

  // Initial check
  if (mediaQuery.matches) {
    setupSlider();
  }
});
